module.exports = __webpack_public_path__ + "img/ico-ayar.cdf37851.svg";